import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import StarIcon from "@mui/icons-material/Star";
import PersonIcon from "@mui/icons-material/Person";
import "./Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.log("No token found. Redirecting to login.");
      navigate("/login");
    } else {
      console.log("Token found. Loading dashboard...");
    }
  }, [navigate]);

  console.log("Rendering Dashboard Component...");

  const handleLogout = () => {
    console.log("Redirecting to logout page...");
    navigate("/logout"); // Navigate to the logout route
  };

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <div className="sidebar-header">Chameye</div>
        <List>
          <ListItem
            button
            onClick={() => navigate("/dashboard")}
            style={{ cursor: "pointer" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976d2")
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard Page" />
          </ListItem>
          <ListItem
            button
            onClick={() => navigate("/profile")}
            style={{ cursor: "pointer" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976d2")
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
          >
            <ListItemIcon>
              <LightbulbIcon />
            </ListItemIcon>
            <ListItemText primary="Profile" />
          </ListItem>
          <ListItem
            button
            onClick={() => navigate("/report")}
            style={{ cursor: "pointer" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976d2")
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
          >
            <ListItemIcon>
              <StarIcon />
            </ListItemIcon>
            <ListItemText primary="Report" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem
            button
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#1976d2")
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "")}
          >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Sign Out" />
          </ListItem>
        </List>
      </aside>
      <main className="content">
        <h1>Welcome to the Dashboard!</h1>
        <p>This is your main content area.</p>
      </main>
    </div>
  );
};

export default Dashboard;
